import apiClient from './apiClient';

export const getDashboardStats = async (params = {}) => {
  try {
    const response = await apiClient.get('/dashboard/all', { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};
